export default __webpack_public_path__ + "static/realWorldImage2-9da072f069d5e189c0791ac4f84463d1.png";